module.exports = __webpack_public_path__ + "img/ccs-logo-dark.5f59ca81.png";